<template>
  <div class="container">
    <div class="flow-container">
      <div class="top-container">
        <div class="background-img"></div>
        <div class="user" @click="clickTime++">
          <div class="user-header" :class="isVip ? 'img-vip' : ''">
            <img :src="faceUrl" />
            <div class="vipicon" v-if="isVip"></div>
          </div>
          <span id="username" :class="isVip ? 'vip-name' : ''">
            {{ username }}&nbsp;
            <img src="../assets/images/vip.png" v-show="isVip" />
          </span>
          <div class="userdate">
            <span v-if="isVip">有效期至：{{ vipLength }}</span>
            <span v-else-if="isVipExpire">
              <img src="../assets/vip-expire.png" class="expire-img" />
              <p class="expire-text">会员已过期</p>
            </span>
            <span v-else>普通用户</span>
          </div>
          <span class="userspace"> 我的空间:{{ mySpace }} </span>
        </div>
      </div>
      <div class="bottom-container">
        <div class="vip-container vip-buy-container">
          <div class="buy-header">
            会员仅需
            <span style="color: #e0b14d">{{ minPrice }}元</span
            >/月，立享多项尊贵特权
          </div>
          <div class="vip-buy">
            <div
              v-for="item in productList"
              :key="item.m_product"
              class="vip-buy-item"
              :class="{
                'select-item':
                  selectProduct && selectProduct.m_product == item.m_product,
              }"
              @click="chooseProduct(item)"
            >
              <p class="length">{{ item.name }}</p>
              <div class="priceNow">
                <p>
                  <span class="icon">￥</span>
                  <span class="num">{{ item.price }}元</span>
                </p>
              </div>
              <div class="priceLast">
                <p>
                  <span class="del">￥{{ item.old_price }}</span
                  >&nbsp;
                  <span class="average">{{ item.perMonth }}元/月</span>
                </p>
              </div>
              <span v-if="item.label" class="label-box">
                <img src="@/assets/label_bg.png" class="label-bg" />
                <p>{{ item.label }}</p>
              </span>
              <span v-if="item.label && timelimit" class="timelimit"
                >倒计时{{ timelimit }}</span
              >
            </div>
          </div>

          <div class="pay" id="payBtn" @click="openVip">
            {{ selectProduct.btn_doc || btnInfo }}
          </div>
        </div>
        <div class="bar-switch-tab">
          <div
            @click="switchTab('right')"
            class="tab-item"
            :class="tabSelect == 'right' ? 'tab-item-selected' : ''"
          >
            专属特权
          </div>
          <!--福利券的tab只在build号 > 253200 的版本才出现-->
          <div
            @click="switchTab('bonus')"
            class="tab-item"
            :class="tabSelect == 'bonus' ? 'tab-item-selected' : ''"
            v-if="buildNo > 253200"
          >
            独家福利券
          </div>
        </div>
        <!--253200屏蔽升级条-->
        <span v-if="tabSelect == 'right' && !buildNo <= 253200">
          <div
            class="vip-container vip-right-container"
            v-for="(item, index) in vipRights"
            :key="index"
          >
            <div class="vip-header">
              <img class="pointl" src="@/assets/pointl.png" />
              <span class="header-title">{{ item.title }}</span>
              <img class="pointr" src="@/assets/pointr.png" />
            </div>
            <div class="vip-right">
              <div
                class="vip-right-item"
                v-for="(right, idx) in item.rights"
                :key="idx"
                @click="infoClick(index, idx)"
              >
                <img class="right-img" :src="right.img" />
                <span class="right-txt">{{ right.text }}</span>
              </div>
            </div>
          </div>
        </span>
        <div
          class="vip-container vip-bonus-container"
          v-if="tabSelect == 'bonus'"
        >
          <div class="vip-header">
            <img class="pointl" src="@/assets/pointl.png" />
            <span class="header-title">独家福利券</span>
            <img class="pointr" src="@/assets/pointr.png" />
          </div>
          <div class="vip-bonus">
            <div
              class="vip-bonus-item"
              v-for="(item, index) in bonusList"
              :key="index"
              @click="bonusClick(item.id, item.title)"
            >
              <img class="bonus-logo" :src="item.s_logo" />
              <span class="bonus-title">{{ item.title }}</span>
              <span class="bonus-desc">{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="alert" v-if="showAlert">
      <h3>温馨提示</h3>
      <p>登录失效，请重新登录，即可完成购买</p>
      <button class="mainBtn" @click="goRelogin">立即登录</button>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="showAlert" @click="closeAlert"></div>
  </div>
</template>

<script>
let fromBonus = false;
import JsonProxy from '@/utils/jsonproxy';
import Avalon from "@/utils/Avalon";
import fn from '@/utils/commonFn';
import Vue from "vue";
import headerImg from "../assets/headerImg.png";
import {
  isDebug
} from '@/config';
import mockData from "@/mockData";
import NativeApi from "@/utils/nativeApi";
import Midas from '@/utils/Midas';
let napiCient = (window.napiCient = new NativeApi());
import countDown from 'countdown-js';
import Vconsole from 'vconsole';
import moment from 'moment';
export default {
  name: "Vip",
  watch: {
    $route () {
      console.log(this.$route.params);
      if (this.$route.params.openVip) {
        this.openVip();
      }
    },
    clickTime () {
      console.log('this.clickTime:', this.clickTime);
      console.log(this.buildNo);
      if (this.clickTime == 10) {
        let vConsole = new Vconsole();
        Vue.use(vConsole);
      }
    },
    selectProduct (product) {
      this.btnInfo = `${product.hasDiscount ? product.discount + '折' : ''}${this.isVip ? '续期' : '开通'}（支付${product.price}元）`;
    }
  },
  data () {
    return {
      countDown: null,
      showAlert: false,
      selectProduct: {},
      url: "",
      pageReady: false,
      isVip: false,
      isVipExpire: false,
      username: "",
      faceUrl: headerImg,
      vipLength: "",
      mySpace: "",
      productList: [],
      bonusList: [],
      btnInfo: "立即开通",
      trackMap: mockData.trackMap,
      vipRights: mockData.vipRights,
      showIndex: 0,
      minPrice: 0, // 平均最低价格
      tabSelect: 'right',
      timelimit: null,
      clickTime: 0,
      buildNo: 0 //格式转换的特权和福利券的tab只在build号 > 253200 的版本才出现;格式转换的下载提示条在build号 >= 254000才出现
    };
  },
  beforeRouteEnter (to, from, next) {
    console.log('index beforeRouteEnter 2');
    if (from.name == 'Bonus') {
      fromBonus = true;
    }
    next();
  },
  created () {
    this.cnfs = {};
  },
  mounted () {
    let clientInfos = sessionStorage.getItem("clientInfos");
    if (fromBonus) {
      this.tabSelect = 'bonus';
    }
    console.log('index mounted');
    if (clientInfos) {
      this.fromStorage();
    } else {
      this._init = true;
      this.init();
    }
  },
  activated () {
    console.log('index activated');
    let clientInfos = sessionStorage.getItem("clientInfos");
    if (!this._init) {
      this.init();
    } else if (clientInfos) {
      this.fromStorage();
    }
  },
  methods: {
    closeAlert () {
      this.showAlert = false;
    },
    //引导用户重新登录
    goRelogin () {
      this.showAlert = false;
      this.relogin();
      clearTimeout(this.countDown);
    },
    fromStorage () {
      this.showLoading();
      let productList = sessionStorage.getItem("productList");
      this.productList = JSON.parse(productList);
      let isVip = sessionStorage.getItem("isVip");
      let isVipExpire = sessionStorage.getItem("isVipExpire");
      let vipLength = sessionStorage.getItem("vipLength");
      let minPrice = sessionStorage.getItem("minPrice");
      let bonusList = sessionStorage.getItem("bonusList");
      let mySpace = sessionStorage.getItem("mySpace");
      let clientInfos = sessionStorage.getItem("clientInfos");
      this.isVip = isVip == 1 ? true : false;
      this.globalData.isVip = this.isVip;
      this.isVipExpire = isVipExpire == 1 ? true : false;
      this.vipLength = vipLength;
      this.minPrice = minPrice;
      this.bonusList = JSON.parse(bonusList);
      this.clientInfos = JSON.parse(clientInfos);
      console.log('this.clientInfos:', this.clientInfos);
      this.buildNo = this.clientInfos.buildNo;
      console.log('this.buildNo:', this.buildNo);
      this.username = this.clientInfos.mainAccount.nickname || "我的账号";
      this.faceUrl = this.clientInfos.mainAccount.faceUrl || headerImg;
      this.mySpace = mySpace;
      this.pageReady = true;
      let selectProduct = sessionStorage.getItem("selectProduct");
      this.selectProduct = JSON.parse(selectProduct);
      this.hideLoading();
    },
    relogin () {
      napiCient.login().then(res => {
        console.log('login:', res);
        if (res.ret == 0) {
          this.needLogin = false;
          this.init();
        }
      }).catch(e => {
        console.log('error:', e);

      });
    },
    init () {
      this.showLoading();
      // 获取所有用户信息
      //初始化会员套餐信息
      this.getVipProds();
      this.getAllInfo()
        .then(infos => {
          this.clientInfos = infos;
          sessionStorage.setItem("clientInfos", JSON.stringify(infos));
          this.buildNo = infos.buildNo;

          let _mainAccountInfo = this.clientInfos.mainAccount;
          if (_mainAccountInfo.state !== 'online') {
            this.needLogin = true;
            this.username = '未登录';
            this.hideLoading();
            return;
          }
          if (!_mainAccountInfo.wx_openId && !_mainAccountInfo.open_id) {
            this.showToast({
              title: "暂不支持手机账号开通会员,请切换QQ,微信登录后重试"
            });
            this.needLogin = true;
            this.pageReady = true;
          }
          this.account_type = _mainAccountInfo.wx_openId ? 'wx' : 'qq'; //类型
          console.log('_mainAccountInfo:', _mainAccountInfo);

          //获取会员套餐信息
          this.getVipProds(true);
          this.username =
            this.clientInfos.mainAccount.nickname || "我的账号";
          this.faceUrl =
            this.clientInfos.mainAccount.faceUrl || headerImg;
          // 获取套餐信息
          this.getProducts()
            .then(datas => {
              // 判断用户状态
              let _vipInfos = datas.vipInfoProfile;
              console.log("vip信息", _vipInfos);
              this.mySpace = fn.memory(_vipInfos.totalStorageForA);
              sessionStorage.setItem("mySpace", this.mySpace);
              console.log(
                "过期时间",
                _vipInfos.expireDate * 1000 - new Date().getTime()
              );
              let totalValidDays =
                _vipInfos.expireDate * 1000 - new Date().getTime();
              if (_vipInfos.vipLevel > 0) {
                this.isVip = true;
                sessionStorage.setItem("isVip", 1);
                this.globalData.isVip = true;
                // 统计剩余天数
                this.vipLength = fn.dateFormat(
                  totalValidDays,
                  "%Y.%m.%d"
                );
                sessionStorage.setItem("vipLength", this.vipLength);
                napiCient.run("getReportUserActionTo3GFeature", [
                  this.trackMap["vipShow"]
                ]);
              } else {
                this.globalData.isVip = false;
                if (_vipInfos.expireDate > 0) {
                  this.isVipExpire = true;
                  sessionStorage.setItem("isVipExpire", 1);
                }
                napiCient.run("getReportUserActionTo3GFeature", [
                  this.trackMap["userShow"]
                ]);
              }
              napiCient.run("getReportUserActionTo3GFeature", [
                this.trackMap["showAll"]
              ]);
              this.hideLoading();
            })
            .catch(err => {
              this.hideLoading();
              console.log("getallinfo fail,", err);
            });

          Avalon.getBonusList().then(res => {
            this.bonusList = res.bonus;
            sessionStorage.setItem("bonusList", JSON.stringify(res.bonus));
          });
        })
        .catch(e => {
          this.hideLoading();
        });
    },

    getVipProds (isReal = false) {
      console.log('account_type---', JSON.stringify(this.account_type));
      //获取会员套餐 7-4-wx/qq
      Avalon.getVipProds(7, 4, this.account_type).then(productList => {
        //fix占位套餐比真实套餐晚获取的情况
        if (!isReal && this.productList.length) {
          return;
        }
        productList = productList.filter(item => {
          //最高版本
          if (item.height_version) {
            return this.buildNo <= parseFloat(item.height_version);
          }
          //最低版本
          if (item.version) {
            return this.buildNo >= parseFloat(item.version);
          }
          return true;
        });
        if (isReal) {
          this.pageReady = true;
        }
        this.selectProduct = productList.find(item => {
          return item.is_default == 1;
        }) || productList[0];
        sessionStorage.setItem("selectProduct", JSON.stringify(this.selectProduct));
        this.productList = productList;
        sessionStorage.setItem("productList", JSON.stringify(this.productList));
        const pricelist = productList.map(item => parseFloat(item.perMonth));
        this.minPrice = Math.min(...pricelist);
        sessionStorage.setItem("minPrice", this.minPrice);
        if (productList.some(item => !item.label)) {
          // this.countTime();
        }
      }).catch(e => {
        if (isReal) {
          this.pageReady = true;
        }
        console.log(e);
      });
    },
    chooseProduct (product) {
      console.log('chooseProduct:', product);
      this.selectProduct = product;
      sessionStorage.setItem("selectProduct", JSON.stringify(this.selectProduct));
    },
    countTime () {
      const end = new Date('2020-09-24T16:00:00.000Z');
      const formatTime = function (time) {
        return `${time < 10 ? ('0' + time) : time}`;
      };
      countDown.timer(end, (timeLeft) => {
        if (timeLeft.days && timeLeft.days > 0) {
          this.timelimit = `${timeLeft.days}天`;
        } else {
          this.timelimit = `${formatTime(timeLeft.hours)}:${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`;
        }
      }, () => {
        this.timelimit = null;
      });
    },
    // 获取所有参数,
    getAllInfo () {
      if (isDebug) {
        return new Promise(resolve => {
          resolve(mockData.accountInfo);
        });
      }
      // 获取guid lc imei
      console.log("获取信息");
      let needinfos = ["guid", "lc", "imei"];
      let ret = {};
      let promiseQue = needinfos.map(key => {
        return new Promise((resolve, reject) => {
          napiCient.run("getInfo", [
            key,
            function (res) {
              resolve({
                key: key,
                data: res && res.ret
              });
            }
          ]);
        });
      });
      //获取buildno
      promiseQue.push(new Promise((resolve, reject) => {
        napiCient.run('getBuildNo', [(res) => {
          let tmp = res && res.ret;
          tmp && (tmp = parseInt(tmp));
          resolve({
            key: 'buildNo',
            data: tmp || 0
          });
        }]);
      }));
      // 获取platform
      promiseQue.push(
        new Promise((resolve, reject) => {
          napiCient.run("getPlatform", [
            ret => {
              resolve({
                key: "platform",
                data: ret && ret.ret
              });
            }
          ]);
        })
      );
      // 获取username,loginkey,openId,nickname,faceUrl
      promiseQue.push(
        new Promise((resolve, reject) => {
          this.getAccountInfo()
            .then(ret => {
              ret.uin = ret.uin || ret.qq_uin;
              ret.nickname =
                ret.nickname ||
                ret.qq_nickname ||
                ret.wx_nickname;
              ret.faceUrl =
                ret.faceUrl || ret.qq_faceUrl || ret.wx_faceUrl;
              console.log("获取账号状态", ret);
              resolve({
                key: "mainAccount",
                data: ret
              });
            })
            .catch(err => {
              console.log("get main account fail!", err);
              reject(err);
            });
        })
      );
      return Promise.all(promiseQue)
        .then(datas => {
          return new Promise((resolve, reject) => {
            datas.forEach(item => {
              ret[item.key] = item.data;
            });
            resolve(ret);
          });
        })
        .catch(err => {
          console.log("get main account fail!", err);
          reject(err);
        });
    },
    // 获取产品信息
    getProducts () {
      return new Promise((resolve, reject) => {
        //debugger
        // console.log("mockData:", mockData);
        if (isDebug) {
          let debugInfos = mockData.productInfo;
          console.log("debugInfos:", debugInfos);
          return resolve(debugInfos.data.resp);
        }

        if (!this.clientInfos) {
          return reject("missing client info");
        }
        let _info = this.clientInfos;
        let _mainAccountInfo = _info.mainAccount;
        this._mainAccountInfo = _mainAccountInfo;
        let opts = {
          authContext: {
            qqpimAuthInfo: {
              accType: _mainAccountInfo.wx_openId ? 7 : 10,
              acc: _mainAccountInfo.accountid,
              loginKey: _mainAccountInfo.token,
              LC: _info.lc,
              language: 1,
              refreshKey: ""
            }
          }
        };

        console.log("_mainAccountInfo---" + _mainAccountInfo);
        console.log("_mainAccountInfo---" + JSON.stringify(_mainAccountInfo));

        console.log("get production params", opts);
        JsonProxy
          .getVipProductsMsgReq(opts)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            return reject(
              "request jsonproxy fail, res:",
              JSON.stringify(err)
            );
          });
      });
    },
    getAccountInfo () {
      return new Promise((resolve, reject) => {
        napiCient.run("getMainAccountInfo", [
          ret => {
            if (ret && ret.ret == 0) {
              console.log('--main:', ret);
              resolve(ret);
            } else {
              reject(ret);
            }
          }
        ]);
      });
    },
    // 提交支付
    openVip () {
      if (this.needLogin) {
        return this.relogin();
      }
      if (this.clicked || !this.pageReady) {
        return;
      }
      this.clicked = true;
      let {
        m_service,
        m_offer,
        m_product,
        is_continous = 0,
        month
      } = this.selectProduct;
      //获取用户选择
      let _info = this.clientInfos;
      let _mainAccountInfo = _info.mainAccount;
      // 上报点击
      let _type = this.track(month);
      let _allType = "allChoose" + month;
      napiCient.run("getReportUserActionTo3GFeature", [
        this.trackMap[_type]
      ]);
      napiCient.run("getReportUserActionTo3GFeature", [
        this.trackMap[_allType]
      ]);
      napiCient.run("getReportUserActionTo3GFeature", [
        this.trackMap["choosePay"]
      ]);
      if (this.isVip) {
        napiCient.run("getReportUserActionTo3GFeature", [
          this.trackMap["vipChoosePay"]
        ]);
      } else {
        napiCient.run("getReportUserActionTo3GFeature", [
          this.trackMap["userChoosePay"]
        ]);
      }
      this.showLoading();

      let opts = {
        account: _mainAccountInfo.accountid, //同步助手账号
        loginkey: _mainAccountInfo.token,
        accType: _mainAccountInfo.wx_openId ? 7 : 10, //账号类型 7：微信  10： OpenQQ
      };
      console.log("opts" + JSON.stringify(opts));

      let type = _mainAccountInfo.wx_openId ? 'wx' : 'qq'; //类型
      let openId = _mainAccountInfo.wx_openId ?
        _mainAccountInfo.wx_openId :
        _mainAccountInfo.open_id;

      const vipLevel = this.isVip ? 1 : 0;
      JsonProxy
        .getMidasProductTokenReq(opts)
        .then(res => {
          this.clicked = false;
          //登录态失效
          if (res.retCode == -40001) {
            //上报 客户端登录态失效错误码上报
            if (_sdi) {
              console.log('客户端登录态失效错误码上报');
              _sdi.stat({ ptype: '13', stype: '69' });
            }
            this.hideLoading();
            console.log('登录态失效：', res.retCode);
            this.showAlert = true;
            let createTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            Avalon.appAddCode(res.retCode, createTime)
              .then(res => {
                console.log('ERROR CODE', res.data);
              }).catch(e => {
                console.log(e);
              });

            this.countDown = setTimeout(() => {
              this.showAlert = false;
              this.relogin();
            }, 5000);

            return;
          }
          let openKey = res.accessToken;
          console.log('openKey:', openKey);
          this.hideLoading();
          let url = Midas.payTemplate(type, m_service, m_offer, m_product, openId, openKey, is_continous, month, vipLevel);
          console.log('url:', url);
          window.location.href = url;
        })
        .catch(err => {
          this.hideLoading();
          this.clicked = false;
        });
    },
    reloadCurrent () {
      console.log("reload");
      window.location.reload();
    },
    track (index) {
      if (this.isVip) {
        return "vipChoose" + index;
      } else {
        return "userChoose" + index;
      }
    },
    infoClick (vipIdx, infoIdx) {
      if (!this.pageReady) {
        return;
      }
      this.globalData.info = this.vipRights[vipIdx].info;
      this.$router.push({
        name: "Right",
        params: {
          showIndex: infoIdx
        }
      });
    },
    bonusClick (id, title) {
      if (!id) {
        return;
      }
      napiCient.doStringEmid(this.trackMap["clickBonus"], title);
      this.$router.push({
        name: 'Bonus',
        params: {
          mid: id
        }
      });
    },
    switchTab (tab) {
      if (!this.pageReady) {
        return;
      }
      console.log("tab:", tab);
      this.tabSelect = tab;
      if (tab == 'bonus') {
        napiCient.run("getReportUserActionTo3GFeature", [
          this.trackMap["clickBonusTab"]
        ]);
      }
    },
    updateApk () {
      console.log('updateApk');
      this.showToast({
        title: "请等待..."
      });
      napiCient.download('https://tool.m.qq.com/j/pim_vip_upgrade', 'com.tencent.qqpim', 5000015);
    }
  }
};
</script> 

<style scoped lang="less" src="../styles/index.less">
</style>
